import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Funciona para mi celular?',
  answer: 'Sí, el manual cubre tanto teléfonos Android (Samsung, Motorola, Xiaomi, etc.) como iPhone. Las explicaciones están separadas claramente para que encuentres exactamente lo que necesitás según tu modelo.'
}, {
  question: '¿Es difícil de entender?',
  answer: 'Para nada. Está escrito específicamente para personas sin conocimientos técnicos. Usamos lenguaje cotidiano, letra grande y muchas fotos paso a paso. Si sabés leer este texto, vas a entender el manual perfectamente.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Tenés una garantía total de 7 días. Si sentís que el manual no es lo que esperabas o no te ayuda, nos escribís un email y te devolvemos el 100% de tu dinero sin hacer preguntas. El riesgo es todo nuestro.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Es un producto digital. Apenas realizás el pago, recibís un email con el enlace de descarga inmediato. Podés leerlo en tu celular, tablet, computadora o incluso imprimirlo si preferís el papel.'
}, {
  question: '¿Necesito conocimientos previos?',
  answer: 'Ninguno. El manual empieza desde cero absoluto. Asumimos que no sabés nada y te llevamos de la mano paso a paso hasta que te sientas seguro usando tu teléfono.'
}, {
  question: '¿Incluye soporte si tengo dudas?',
  answer: 'Sí, con tu compra tenés acceso a soporte prioritario por email. Si te trabás en algún paso, nos escribís y una persona real te ayuda a resolverlo.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-13">
      {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-blue-100 overflow-hidden" data-id="element-14">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-blue-50 transition-colors" data-id="element-15">
            <span className="font-bold text-lg text-slate-800 pr-8" data-id="element-16">
              {faq.question}
            </span>
            <motion.div animate={{
          rotate: openIndex === index ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-17">
              <ChevronDown className="w-6 h-6 text-blue-600" data-id="element-18" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-19">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="overflow-hidden" data-id="element-20">
                <div className="px-6 pb-6 pt-2 text-slate-600 leading-relaxed border-t border-blue-50" data-id="element-21">
                  {faq.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}